import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const FONTS_URL =
  "https://fonts.googleapis.com/css2?family=Instrument+Serif:ital@0;1&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600&display=swap";

function useFonts() {
  useEffect(() => {
    if (document.querySelector('link[href*="Instrument+Serif"]')) return;
    const l = document.createElement("link");
    l.rel = "stylesheet";
    l.href = FONTS_URL;
    document.head.appendChild(l);
  }, []);
}

const T = {
  g700: "#155c36", g600: "#1b7a47", g500: "#1e9254", g400: "#28b566",
  g200: "#a7d9bc", g100: "#d6f0e3", g50: "#eef8f3",
  n900: "#0f1117", n800: "#1c2130", n700: "#2d3549", n600: "#4a5268",
  n400: "#8a93a8", n300: "#b0b8cc", n200: "#d1d5e0", n150: "#e4e7ef",
  n100: "#eef0f5", n50: "#f7f8fa", white: "#ffffff",
  serif: "'Instrument Serif', Georgia, serif",
  sans: "'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif",
};

const Icon = ({ name, size = 20, color = "currentColor", strokeWidth = 1.6 }) => {
  const paths = {
    ArrowLeft:    <><path d="M19 12H5"/><path d="m12 19-7-7 7-7"/></>,
    ArrowRight:   <><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></>,
    Search:       <><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></>,
    Star:         <><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></>,
    Shield:       <><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></>,
    MapPin:       <><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z"/><circle cx="12" cy="10" r="3"/></>,
    Award:        <><circle cx="12" cy="8" r="6"/><path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"/></>,
    Filter:       <><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></>,
    CheckCircle:  <><circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/></>,
    MessageCircle:<><path d="m3 21 1.9-5.7a8.5 8.5 0 1 1 3.8 3.8z"/></>,
    Clock:        <><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></>,
    Eye:          <><path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7z"/><circle cx="12" cy="12" r="3"/></>,
    Camera:       <><path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3z"/><circle cx="12" cy="13" r="3"/></>,
    Sliders:      <><line x1="4" x2="4" y1="21" y2="14"/><line x1="4" x2="4" y1="6" y2="3"/><line x1="12" x2="12" y1="21" y2="12"/><line x1="12" x2="12" y1="4" y2="3"/><line x1="20" x2="20" y1="21" y2="16"/><line x1="20" x2="20" y1="8" y2="3"/><line x1="1" x2="7" y1="14" y2="14"/><line x1="9" x2="15" y1="12" y2="12"/><line x1="17" x2="23" y1="16" y2="16"/></>,
    Users:        <><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></>,
    Sparkles:     <><path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3z"/></>,
    ThumbsUp:     <><path d="M7 10v12"/><path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88z"/></>,
    AlertCircle:  <><circle cx="12" cy="12" r="10"/><line x1="12" x2="12" y1="8" y2="12"/><line x1="12" x2="12.01" y1="16" y2="16"/></>,
    Lightbulb:    <><path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5"/><path d="M9 18h6"/><path d="M10 22h4"/></>,
    Home:         <><path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></>,
    Wrench:       <><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></>,
    Droplets:     <><path d="M7 16.3c2.2 0 4-1.83 4-4.05 0-1.16-.57-2.26-1.71-3.19S7.29 6.75 7 5.3c-.29 1.45-1.14 2.84-2.29 3.76S3 11.1 3 12.25c0 2.22 1.8 4.05 4 4.05z"/><path d="M12.56 6.6A10.97 10.97 0 0 0 14 3.02c.5 2.5 2 4.9 4 6.5s3 3.5 3 5.5a6.98 6.98 0 0 1-11.91 4.97"/></>,
    ChevronDown:  <><path d="m6 9 6 6 6-6"/></>,
    ChevronUp:    <><path d="m18 15-6-6-6 6"/></>,
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24"
      fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
      {paths[name]}
    </svg>
  );
};

/* ── Service category chips ── */
const CATEGORIES = [
  { icon: "Droplets", label: "Plumbing" },
  { icon: "Wrench",   label: "Electrical" },
  { icon: "Home",     label: "Cleaning" },
  { icon: "Sparkles", label: "Painting" },
  { icon: "Lightbulb",label: "Appliance repair" },
  { icon: "Camera",   label: "Security install" },
  { icon: "Users",    label: "Gardening" },
  { icon: "Sliders",  label: "Carpentry" },
];

function CategoryChip({ icon, label, onClick }) {
  const [hovered, setHovered] = useState(false);
  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: "inline-flex", alignItems: "center", gap: 8,
        padding: "10px 16px", borderRadius: 99,
        border: `1.5px solid ${hovered ? T.g500 : T.n150}`,
        background: hovered ? T.g50 : T.white,
        cursor: "pointer", fontFamily: T.sans,
        fontSize: 13, fontWeight: 500,
        color: hovered ? T.g700 : T.n700,
        transition: "all .15s",
      }}>
      <Icon name={icon} size={14} color={hovered ? T.g500 : T.n400} strokeWidth={1.8} />
      {label}
    </button>
  );
}

/* ── Tip card ── */
function TipCard({ num, icon, title, desc, tags }) {
  return (
    <div style={{
      padding: "28px 0",
      borderBottom: `1px solid ${T.n100}`,
      display: "flex", gap: 20,
    }}>
      <div style={{
        width: 44, height: 44, borderRadius: 12, flexShrink: 0,
        background: T.g50, border: `1.5px solid ${T.g100}`,
        display: "flex", alignItems: "center", justifyContent: "center",
      }}>
        <Icon name={icon} size={19} color={T.g500} strokeWidth={1.6} />
      </div>
      <div style={{ flex: 1, paddingTop: 2 }}>
        <div style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 5 }}>
          Tip {num}
        </div>
        <h3 style={{ fontFamily: T.serif, fontSize: "clamp(18px,2.5vw,22px)", fontWeight: 400, color: T.n900, margin: "0 0 9px", letterSpacing: "-0.02em", lineHeight: 1.25 }}>
          {title}
        </h3>
        <p style={{ fontSize: 15, color: T.n600, lineHeight: 1.75, margin: "0 0 14px" }}>{desc}</p>
        {tags && (
          <div style={{ display: "flex", flexWrap: "wrap", gap: 7 }}>
            {tags.map((tag, i) => (
              <span key={i} style={{
                fontSize: 12, color: T.g700, background: T.g50,
                border: `1px solid ${T.g100}`, borderRadius: 99,
                padding: "3px 11px", fontWeight: 500,
                display: "inline-flex", alignItems: "center", gap: 5,
              }}>
                <Icon name="CheckCircle" size={11} color={T.g500} strokeWidth={2.2} />
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

/* ── What a great profile looks like — checklist card ── */
function ProfileCheckItem({ icon, title, desc, good }) {
  return (
    <div style={{
      display: "flex", gap: 14, padding: "16px 0",
      borderBottom: `1px solid ${T.n100}`,
    }}>
      <div style={{
        width: 32, height: 32, borderRadius: 9, flexShrink: 0,
        background: good ? T.g50 : "#fef2f2",
        border: `1px solid ${good ? T.g100 : "#fecaca"}`,
        display: "flex", alignItems: "center", justifyContent: "center",
        marginTop: 1,
      }}>
        <Icon name={icon} size={15} color={good ? T.g500 : "#ef4444"} strokeWidth={1.8} />
      </div>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 14, fontWeight: 600, color: T.n800, marginBottom: 3, lineHeight: 1.3 }}>{title}</div>
        <div style={{ fontSize: 13, color: T.n400, lineHeight: 1.6 }}>{desc}</div>
      </div>
      <div style={{
        fontSize: 11, fontWeight: 600, letterSpacing: "0.05em",
        color: good ? T.g600 : "#dc2626",
        background: good ? T.g50 : "#fef2f2",
        border: `1px solid ${good ? T.g100 : "#fecaca"}`,
        borderRadius: 99, padding: "3px 10px", alignSelf: "flex-start",
        flexShrink: 0, marginTop: 1,
      }}>
        {good ? "Look for" : "Avoid"}
      </div>
    </div>
  );
}

/* ── FAQ ── */
function FaqItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ borderBottom: `1px solid ${T.n100}` }}>
      <button onClick={() => setOpen(o => !o)} style={{
        width: "100%", display: "flex", justifyContent: "space-between",
        alignItems: "center", padding: "18px 0", background: "none",
        border: "none", cursor: "pointer", fontFamily: T.sans, textAlign: "left", gap: 16,
      }}>
        <span style={{ fontSize: 15, fontWeight: 600, color: T.n800, lineHeight: 1.4 }}>{q}</span>
        <span style={{ flexShrink: 0, color: T.n400 }}>
          <Icon name={open ? "ChevronUp" : "ChevronDown"} size={18} strokeWidth={2} />
        </span>
      </button>
      {open && (
        <p style={{ fontSize: 14, color: T.n600, lineHeight: 1.75, margin: "0 0 18px", paddingRight: 32 }}>{a}</p>
      )}
    </div>
  );
}

/* ── Filter explainer pill ── */
function FilterPill({ icon, label, desc }) {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        padding: "16px 18px", borderRadius: 14,
        border: `1.5px solid ${hovered ? T.g200 : T.n150}`,
        background: hovered ? T.g50 : T.white,
        transition: "all .15s", cursor: "default",
      }}>
      <div style={{ display: "flex", alignItems: "center", gap: 9, marginBottom: 7 }}>
        <Icon name={icon} size={16} color={T.g500} strokeWidth={1.8} />
        <span style={{ fontSize: 13, fontWeight: 600, color: T.n800 }}>{label}</span>
      </div>
      <p style={{ fontSize: 13, color: T.n600, lineHeight: 1.6, margin: 0 }}>{desc}</p>
    </div>
  );
}

/* ══ Main page ══ */
export default function FindAJiraniProPage() {
  useFonts();
  const navigate = useNavigate();

  const handleCategorySearch = (label) => {
    navigate(`/search?q=${encodeURIComponent(label)}`);
  };

  const tips = [
    {
      num: "01", icon: "Search", title: "Start with the right search term",
      desc: "Be as specific as you can. Instead of searching \"repairs\", try \"bathroom tap repair\" or \"ceiling fan installation\". Specific searches surface pros who specialise in exactly what you need, and their profiles will reflect relevant experience and past jobs.",
      tags: ["Specific beats generic", "Use the service type", "Add detail if you can"],
    },
    {
      num: "02", icon: "MapPin", title: "Check their location and distance",
      desc: "JiraniApp prioritises professionals near you, but you can see exact distance on every profile. Closer is usually better for same-day jobs or anything that might need a follow-up visit. For large or complex jobs, a slightly further pro with a stronger record is often worth it.",
      tags: ["Distance shown on every card", "Filter by proximity", "Consider travel time"],
    },
    {
      num: "03", icon: "Star", title: "Read reviews properly, not just the star rating",
      desc: "A 4.8-star average means little without context. Read the actual written reviews. Look for comments about punctuality, quality of work, communication, and how the pro handled any issues. A pro with 20 detailed reviews is often more trustworthy than one with 200 one-line ratings.",
      tags: ["Read the text, not just stars", "Look for repeated praise", "Check recent reviews"],
    },
    {
      num: "04", icon: "Eye", title: "Study the profile before you book",
      desc: "A complete profile is a signal of a professional who takes their work seriously. Look for a clear photo, a detailed service description, portfolio images of past jobs, and defined pricing. Vague profiles with no photos or incomplete descriptions are a sign to look elsewhere.",
      tags: ["Portfolio photos matter", "Clear pricing listed", "Detailed service bio"],
    },
    {
      num: "05", icon: "Award", title: "Look for the Verified badge",
      desc: "Every JiraniPro with a Verified badge has completed our identity verification and background check process. This does not guarantee perfect work, but it does mean we know who they are, they have been reviewed by our team, and they are accountable through the platform.",
      tags: ["ID verified", "Background checked", "Platform accountable"],
    },
    {
      num: "06", icon: "MessageCircle", title: "Message before you book if you are unsure",
      desc: "JiraniApp lets you message a professional before committing to a booking. Use this if your job has unusual requirements, you need to confirm pricing for a complex scope, or you simply want a feel for how responsive and communicative they are. Response time is visible on every profile.",
      tags: ["Free to message first", "Check response rate", "Clarify scope upfront"],
    },
    {
      num: "07", icon: "Clock", title: "Check availability carefully",
      desc: "JiraniPros set their own live availability, so what you see is real. If you have a specific deadline or need someone urgently, filter by availability window first. For non-urgent jobs, booking a day or two ahead usually gives you a wider choice of top-rated professionals.",
      tags: ["Live availability only", "Filter by date", "Book ahead for more choice"],
    },
    {
      num: "08", icon: "Sliders", title: "Use filters to narrow it down fast",
      desc: "If your search returns many results, filters are the fastest way to find the right match. You can sort by rating, price range, distance, or availability. Use a combination rather than relying on a single filter alone for the best results.",
      tags: ["Sort by rating", "Filter by price", "Combine filters"],
    },
  ];

  const profileChecklist = [
    { icon: "Camera",       title: "Clear, professional profile photo",      desc: "Shows accountability and professionalism. Pros without photos are harder to trust.", good: true },
    { icon: "Star",         title: "High rating with detailed reviews",       desc: "Look for consistent praise across multiple jobs, not just one glowing review.", good: true },
    { icon: "Award",        title: "Verified badge displayed",                desc: "Identity and background check completed. This is a baseline requirement to look for.", good: true },
    { icon: "Eye",          title: "Portfolio photos of real past work",      desc: "Shows the quality of their actual output, not just what they claim they can do.", good: true },
    { icon: "Clock",        title: "Fast response time",                      desc: "Pros who respond quickly tend to be more organised and reliable on the day of the job.", good: true },
    { icon: "CheckCircle",  title: "Clearly listed services and pricing",     desc: "Transparent pricing means no surprises. Avoid profiles that say 'price on request' for standard jobs.", good: true },
    { icon: "AlertCircle",  title: "No reviews or very few reviews",          desc: "Not necessarily bad, but proceed carefully. Ask questions and start with a small job if possible.", good: false },
    { icon: "AlertCircle",  title: "Vague service descriptions",              desc: "If a pro cannot describe what they do clearly, that uncertainty often extends to the work itself.", good: false },
  ];

  const filters = [
    { icon: "Star",     label: "Rating",       desc: "Sort from highest to lowest rating. Best for finding the most trusted professional regardless of price." },
    { icon: "MapPin",   label: "Distance",     desc: "Surface the closest available pros first. Useful for urgent jobs where fast arrival matters." },
    { icon: "Filter",   label: "Price range",  desc: "Set a budget and see only pros within it. Prices shown are the pro's standard rates for the service." },
    { icon: "Clock",    label: "Availability", desc: "Filter by a specific date or time window. Only shows pros who have marked themselves available." },
    { icon: "Award",    label: "Verified only", desc: "Limit results to JiraniPros who have completed full identity and background verification." },
    { icon: "ThumbsUp", label: "Top reviewed", desc: "Filter to professionals with a minimum number of completed, reviewed jobs for added confidence." },
  ];

  const faqs = [
    { q: "Can I see a professional's pricing before I book?", a: "Yes. Every JiraniPro sets and displays their standard pricing on their profile. For straightforward jobs, the price shown is what you pay. For larger or more complex jobs, you can message the pro directly to confirm the full scope and cost before committing to a booking." },
    { q: "What does the Verified badge actually mean?", a: "A Verified badge means the JiraniPro has submitted and passed our identity verification process. We confirm their full name, ID document, and where required, conduct a background check. It means we know who they are and they are accountable through the platform if anything goes wrong." },
    { q: "What if I cannot find a professional for my specific job?", a: "Try broadening your search term or searching by a related category. If you still cannot find what you need, visit our Help and Support page and our team can assist with finding the right match for unusual or specialist jobs." },
    { q: "Can I book the same professional again?", a: "Yes. If you had a great experience, you can go directly to that JiraniPro's profile and book them again. Over time, you can also save favourite professionals from your account for faster rebooking." },
    { q: "Is there a difference between a high price and high quality?", a: "Not always. Some of the most trusted JiraniPros on the platform are mid-range in price. Focus on ratings, review quality, and portfolio over price alone. That said, very low prices on complex jobs can sometimes signal corners being cut, so use your judgement." },
    { q: "What if I want to compare a few professionals before deciding?", a: "Open each profile in a new tab and compare their ratings, reviews, pricing, and response times side by side. There is no pressure to book immediately after viewing a profile, so take the time you need to feel confident in your choice." },
  ];

  return (
    <div style={{ fontFamily: T.sans, background: T.white, minHeight: "100vh", color: T.n900 }}>
      <style>{`
        * { box-sizing: border-box; }
        .jrn-link { color: ${T.g600}; text-decoration: none; border-bottom: 1px solid ${T.g200}; transition: border-color .15s, color .15s; }
        .jrn-link:hover { color: ${T.g700}; border-color: ${T.g600}; }
      `}</style>

      {/* ── Nav ── */}
      <div style={{ padding: "20px 24px", borderBottom: `1px solid ${T.n100}` }}>
        <button onClick={() => navigate(-1)} style={{ display: "inline-flex", alignItems: "center", gap: 6, background: "none", border: "none", cursor: "pointer", color: T.n400, fontSize: 13, fontFamily: T.sans, padding: 0, transition: "color .15s" }}
          onMouseEnter={e => (e.currentTarget.style.color = T.n800)}
          onMouseLeave={e => (e.currentTarget.style.color = T.n400)}>
          <Icon name="ArrowLeft" size={14} strokeWidth={2} />
          Back
        </button>
      </div>

      {/* ── Hero ── */}
      <div style={{ padding: "clamp(48px,7vw,88px) 20px clamp(40px,5vw,60px)", borderBottom: `1px solid ${T.n100}` }}>
        <div style={{ maxWidth: 720, margin: "0 auto" }}>
          <div style={{ display: "inline-flex", alignItems: "center", gap: 7, color: T.g600, fontSize: 12, fontWeight: 600, letterSpacing: "0.09em", textTransform: "uppercase", marginBottom: 20 }}>
            <Icon name="Search" size={13} color={T.g500} strokeWidth={2.2} />
            Find a JiraniPro
          </div>
          <h1 style={{ fontFamily: T.serif, fontSize: "clamp(38px,7vw,62px)", fontWeight: 400, margin: "0 0 18px", lineHeight: 1.07, color: T.n900, letterSpacing: "-0.03em", maxWidth: 600 }}>
            Find someone you can{" "}
            <em style={{ fontStyle: "italic", color: T.g600 }}>actually trust</em>
          </h1>
          <p style={{ fontSize: "clamp(15px,2vw,17px)", color: T.n600, lineHeight: 1.75, margin: "0 0 32px", maxWidth: 540 }}>
            JiraniApp has hundreds of verified home service professionals across Nairobi and beyond.
            This guide walks you through how to search, what to look for, and how to make a confident
            choice every time.
          </p>

          {/* Primary CTA */}
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap", alignItems: "center" }}>
            <button
              onClick={() => navigate("/search")}
              style={{
                padding: "14px 28px", background: T.g500, color: T.white,
                border: "none", borderRadius: 12, fontSize: 15, fontWeight: 600,
                fontFamily: T.sans, cursor: "pointer", letterSpacing: "0.01em",
                display: "inline-flex", alignItems: "center", gap: 9,
              }}
              onMouseEnter={e => (e.currentTarget.style.background = T.g600)}
              onMouseLeave={e => (e.currentTarget.style.background = T.g500)}>
              <Icon name="Search" size={16} color={T.white} strokeWidth={2} />
              Search for a professional
            </button>
            <span style={{ fontSize: 13, color: T.n400 }}>or browse by category below</span>
          </div>
        </div>
      </div>

      <div style={{ maxWidth: 720, margin: "0 auto", padding: "0 20px clamp(80px,10vw,120px)" }}>

        {/* ── Category browser ── */}
        <div style={{ paddingTop: "clamp(40px,6vw,56px)" }}>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(22px,3.5vw,28px)", fontWeight: 400, color: T.n900, margin: "0 0 6px", letterSpacing: "-0.02em", lineHeight: 1.25 }}>
            Browse by <em style={{ fontStyle: "italic", color: T.g600 }}>service type</em>
          </h2>
          <p style={{ fontSize: 14, color: T.n400, margin: "0 0 20px", lineHeight: 1.6 }}>
            Not sure what to search? Start with a category.
          </p>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
            {CATEGORIES.map(c => (
              <CategoryChip key={c.label} icon={c.icon} label={c.label} onClick={() => handleCategorySearch(c.label)} />
            ))}
            <button
              onClick={() => navigate("/search")}
              style={{
                display: "inline-flex", alignItems: "center", gap: 7,
                padding: "10px 16px", borderRadius: 99,
                border: `1.5px dashed ${T.n200}`,
                background: "transparent", cursor: "pointer",
                fontFamily: T.sans, fontSize: 13, fontWeight: 500, color: T.n400,
                transition: "all .15s",
              }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = T.g200; e.currentTarget.style.color = T.g600; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = T.n200; e.currentTarget.style.color = T.n400; }}>
              View all categories
              <Icon name="ArrowRight" size={13} strokeWidth={2} />
            </button>
          </div>
        </div>

        {/* ── How to search ── */}
        <div style={{ marginTop: "clamp(48px,7vw,72px)" }}>
          <div style={{ marginBottom: 6 }}>
            <span style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase" }}>
              How to search
            </span>
          </div>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(24px,4vw,32px)", fontWeight: 400, color: T.n900, margin: "0 0 4px", letterSpacing: "-0.03em", lineHeight: 1.2 }}>
            Eight tips for finding the{" "}
            <em style={{ fontStyle: "italic", color: T.g600 }}>right match</em>
          </h2>
          <p style={{ fontSize: 15, color: T.n400, margin: "0 0 4px", lineHeight: 1.65 }}>
            How to go from results page to confident booking.
          </p>
          <div>
            {tips.map(t => <TipCard key={t.num} {...t} />)}
          </div>
        </div>

        {/* ── Understanding filters ── */}
        <div style={{ marginTop: "clamp(48px,7vw,72px)" }}>
          <div style={{ marginBottom: 6 }}>
            <span style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase" }}>
              Using filters
            </span>
          </div>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(24px,4vw,32px)", fontWeight: 400, color: T.n900, margin: "0 0 6px", letterSpacing: "-0.03em", lineHeight: 1.2 }}>
            What every filter <em style={{ fontStyle: "italic", color: T.g600 }}>actually does</em>
          </h2>
          <p style={{ fontSize: 15, color: T.n400, margin: "0 0 22px", lineHeight: 1.65 }}>
            Filters are most powerful when combined. Here is what each one controls.
          </p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 12 }}>
            {filters.map(f => <FilterPill key={f.label} {...f} />)}
          </div>
        </div>

        {/* ── Reading a profile ── */}
        <div style={{ marginTop: "clamp(48px,7vw,72px)" }}>
          <div style={{ marginBottom: 6 }}>
            <span style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase" }}>
              Reading a profile
            </span>
          </div>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(24px,4vw,32px)", fontWeight: 400, color: T.n900, margin: "0 0 6px", letterSpacing: "-0.03em", lineHeight: 1.2 }}>
            What a strong profile <em style={{ fontStyle: "italic", color: T.g600 }}>looks like</em>
          </h2>
          <p style={{ fontSize: 15, color: T.n400, margin: "0 0 8px", lineHeight: 1.65 }}>
            The signals that separate a trustworthy professional from an uncertain one.
          </p>
          <div>
            {profileChecklist.map((item, i) => <ProfileCheckItem key={i} {...item} />)}
          </div>
        </div>

        {/* ── Guarantee callout ── */}
        <div style={{ marginTop: "clamp(48px,7vw,72px)", padding: "clamp(28px,5vw,40px)", borderRadius: 20, background: T.g50, border: `1px solid ${T.g100}` }}>
          <div style={{ display: "inline-flex", alignItems: "center", gap: 7, color: T.g600, fontSize: 11, fontWeight: 600, letterSpacing: "0.09em", textTransform: "uppercase", marginBottom: 14 }}>
            <Icon name="Shield" size={13} color={T.g500} strokeWidth={2} />
            Jirani Guarantee
          </div>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(22px,3.5vw,30px)", fontWeight: 400, color: T.n900, margin: "0 0 10px", letterSpacing: "-0.03em", lineHeight: 1.2 }}>
            Every booking is <em style={{ fontStyle: "italic", color: T.g600 }}>backed by us</em>
          </h2>
          <p style={{ fontSize: 15, color: T.n600, lineHeight: 1.75, margin: "0 0 20px" }}>
            When you book through JiraniApp, you are protected. Every professional is verified, every
            payment is held securely until the job is done, and our Trust and Safety team is available
            if anything does not go to plan. You are not on your own.
          </p>
          <div style={{ display: "flex", gap: 20, flexWrap: "wrap" }}>
            {[
              { icon: "Award",       text: "Verified professionals only" },
              { icon: "Shield",      text: "Secure payment until completion" },
              { icon: "MessageCircle", text: "Dispute resolution within 48 hours" },
            ].map(b => (
              <div key={b.text} style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 14, color: T.g700, fontWeight: 500 }}>
                <Icon name={b.icon} size={16} color={T.g500} strokeWidth={1.8} />
                {b.text}
              </div>
            ))}
          </div>
        </div>

        {/* ── FAQ ── */}
        <div style={{ marginTop: "clamp(48px,7vw,72px)" }}>
          <div style={{ marginBottom: 6 }}>
            <span style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase" }}>Questions</span>
          </div>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(24px,4vw,32px)", fontWeight: 400, color: T.n900, margin: "0 0 4px", letterSpacing: "-0.03em", lineHeight: 1.2 }}>
            Common <em style={{ fontStyle: "italic", color: T.g600 }}>questions</em>
          </h2>
          <p style={{ fontSize: 15, color: T.n400, margin: "0 0 8px", lineHeight: 1.65 }}>
            Things clients ask when finding a pro for the first time.
          </p>
          <div style={{ marginTop: 8 }}>
            {faqs.map((f, i) => <FaqItem key={i} {...f} />)}
          </div>
        </div>

        {/* ── CTA ── */}
        <div style={{ marginTop: "clamp(48px,7vw,72px)", padding: "clamp(32px,5vw,48px)", borderRadius: 20, border: `1px solid ${T.n150}`, textAlign: "center", background: T.n50 }}>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(26px,4vw,36px)", fontWeight: 400, color: T.n900, margin: "0 0 12px", letterSpacing: "-0.03em", lineHeight: 1.2 }}>
            Ready to find your{" "}
            <em style={{ fontStyle: "italic", color: T.g600 }}>JiraniPro?</em>
          </h2>
          <p style={{ fontSize: 15, color: T.n400, margin: "0 0 28px", lineHeight: 1.65 }}>
            Hundreds of verified professionals are available right now in your area.
          </p>
          <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
            <button
              onClick={() => navigate("/search")}
              style={{
                padding: "13px 28px", background: T.g500, color: T.white,
                border: "none", borderRadius: 11, fontSize: 14, fontWeight: 600,
                fontFamily: T.sans, cursor: "pointer", letterSpacing: "0.01em",
                display: "inline-flex", alignItems: "center", gap: 8,
              }}
              onMouseEnter={e => (e.currentTarget.style.background = T.g600)}
              onMouseLeave={e => (e.currentTarget.style.background = T.g500)}>
              Search professionals
              <Icon name="ArrowRight" size={15} color={T.white} strokeWidth={2} />
            </button>
            <button
              onClick={() => navigate("/how-it-works")}
              style={{
                padding: "13px 28px", background: "transparent", color: T.n700,
                border: `1.5px solid ${T.n200}`, borderRadius: 11, fontSize: 14, fontWeight: 600,
                fontFamily: T.sans, cursor: "pointer", letterSpacing: "0.01em",
              }}
              onMouseEnter={e => (e.currentTarget.style.borderColor = T.n400)}
              onMouseLeave={e => (e.currentTarget.style.borderColor = T.n200)}>
              How JiraniApp works
            </button>
          </div>
        </div>

      </div>
    </div>
  );
}